module.exports = __webpack_public_path__ + "img/rate.4801a8aa.svg";